module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/es.json
// module id = 559
// module chunks = 0